var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigilocker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1274 10.7259V2H8.04808C7.19277 2 6.4939 2.6989 6.4939 3.5543V24.5738C6.4939 25.4291 7.19277 26.1279 8.04808 26.1279H25.4426C26.2979 26.1279 26.9971 25.4291 26.9971 24.5738V10.7259H16.1274Z",
    fill: "#6334FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16229 22.8967C2.84654 22.8811 0.984566 20.9983 1.0001 18.6822C1.01054 17.123 1.88167 15.699 3.26897 14.9846C3.35255 11.9541 5.87698 9.56015 8.90713 9.64345C10.7327 9.69569 12.4173 10.6501 13.3926 12.1941C13.8831 12.001 14.4047 11.9019 14.9313 11.8914C16.8351 11.8914 18.5197 13.1223 19.0884 14.9374C20.5175 15.6467 21.4197 17.1072 21.4146 18.7031C21.4146 20.7842 19.8915 22.5525 17.8366 22.8549V22.8967H5.1572H5.16229Z",
    fill: "#6334FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5645 15.3652C18.0848 13.3522 16.061 12.1055 14.0477 12.5853C13.7348 12.6584 13.4321 12.773 13.1506 12.9244C11.9406 10.5042 8.99881 9.52376 6.58395 10.7337C4.93065 11.5631 3.8822 13.2531 3.87684 15.1046V15.3446C2.02531 16.059 1.10731 18.1401 1.822 19.9916C2.35908 21.3739 3.68906 22.2868 5.17039 22.2868H17.245C19.227 22.2763 20.828 20.6595 20.8229 18.6775C20.8176 17.217 19.9258 15.9077 18.575 15.3601L18.5645 15.3652Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.3298 9.7192H27L17.3298 2V9.7192Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3298 9.7192H27L17.3298 2V9.7192Z",
    fill: "#6334FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2398 17.2699C10.7297 17.2699 11.1265 16.8729 11.1265 16.3833C11.1265 15.8933 10.7297 15.4966 10.2398 15.4966C9.75017 15.4966 9.35315 15.8933 9.35315 16.3833C9.35315 16.8729 9.75017 17.2699 10.2398 17.2699Z",
    fill: "#6334FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4987 16.7119H9.98221L9.38245 19.1892H11.1035L10.4987 16.7119Z",
    fill: "#6334FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigilocker);
export default __webpack_public_path__ + "static/media/DIGILOCKER.ca3f81c0bac0aa244aaf4aa6f04ca317.svg";
export { ForwardRef as ReactComponent };